var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'reveal-image'},[(!_vm.isPassed)?_c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({ active: true, callback: _vm.onWaypoint, options: _vm.intersectionOptions }),expression:"{ active: true, callback: onWaypoint, options: intersectionOptions }"}],staticClass:"reveal-image__waypoint"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }